import { Review } from './reviews';

export default Review;
